export enum HitPerformance {
    CanBeBetter = 1,
    Normal = 2,
    GoingWell = 3
}
